import React from 'react';
import clsx from 'clsx';
import { Button, Icon } from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import { CopyToClipboard } from 'react-copy-to-clipboard';

const HoverActionButtons = ({
  canEdit,
  showEdit,
  position,
  toolTip = 'top right',
  value,
  children,
  editCopyMods,
  disabled,
  copyToClipboard = true,
}) => {
  const intl = useIntl();
  if (!canEdit && !value) {
    return children;
  }
  return (
    <div className={clsx('aridhia-edit-copy', `aridhia-edit-copy--${editCopyMods}`)}>
      <Button.Group
        size="mini"
        className={clsx('aridhia-edit-button-group', position && `aridhia-edit-button-group--${position}`)}
      >
        {canEdit && (
          <Button
            onClick={showEdit}
            data-tooltip={intl.formatMessage({ id: 'actions.edit' })}
            data-variation="mini"
            data-position={toolTip}
            disabled={disabled}
          >
            <Icon name="pencil" className="aridhia-confirm-edit primary" />
          </Button>
        )}
        {value && copyToClipboard && (
          <CopyToClipboard text={value}>
            <Button
              data-tooltip={intl.formatMessage({ id: 'actions.copy' })}
              data-variation="mini"
              data-position={toolTip}
            >
              <Icon name="copy" className="primary" />
            </Button>
          </CopyToClipboard>
        )}
      </Button.Group>
      {children}
    </div>
  );
};

export default HoverActionButtons;
